import { render, staticRenderFns } from "./VirtualPlacement.vue?vue&type=template&id=6682b340&scoped=true&"
import script from "./VirtualPlacement.vue?vue&type=script&lang=js&"
export * from "./VirtualPlacement.vue?vue&type=script&lang=js&"
import style0 from "./VirtualPlacement.vue?vue&type=style&index=0&id=6682b340&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6682b340",
  null
  
)

export default component.exports